import { render, staticRenderFns } from "./ReZoning.vue?vue&type=template&id=bbc5104e&scoped=true"
import script from "./ReZoning.vue?vue&type=script&lang=js"
export * from "./ReZoning.vue?vue&type=script&lang=js"
import style0 from "./ReZoning.vue?vue&type=style&index=0&id=bbc5104e&prod&scoped=true&lang=css"
import style1 from "./ReZoning.vue?vue&type=style&index=1&id=bbc5104e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc5104e",
  null
  
)

export default component.exports